import { useTranslation } from 'react-i18next';
import { Token, TokenVariant } from 'components/Token';
import { GoalStatus } from 'domains/care-plans';

type Props = {
  status: GoalStatus;
};

const statusMapping: Record<GoalStatus, TokenVariant> = {
  met: 'info',
  'partially-met': 'info',
  progressing: 'success',
  modified: 'warning',
  discontinued: 'muted',
};

export const GoalStatusToken = ({ status }: Props): JSX.Element => {
  const { t } = useTranslation();
  if (status in statusMapping) {
    return <Token variant={statusMapping[status]}>{t(`goals.statuses.${status}`)}</Token>;
  }

  return <Token variant="muted">{t(`goals.statuses.${status}`)}</Token>;
};
